import apiClient from "./client";

// fetch list of SiteDto
export function fetchSites() {
  return apiClient.get("/sites").then((res) => res.data);
}

export function createSite(payload) {
  return apiClient.post("/sites", payload).then((res) => res.data);
}

export function uploadSiteLandingHero(siteId, file) {
  const formData = new FormData();
  formData.append("file", file);
  return apiClient
    .post(`/sites/${siteId}/landing-hero`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((res) => res.data);
}

export function removeSiteLandingHero(siteId) {
  return apiClient.delete(`/sites/${siteId}/landing-hero`);
}

export function updateSiteVisitorSkin(siteId, visitorSkin) {
  return apiClient
    .put(`/sites/${siteId}/visitor-skin`, { visitorSkin })
    .then((res) => res.data);
}

export function addSiteHostname(siteId, hostname) {
  return apiClient.post(`/sites/${siteId}/hostnames`, { hostname });
}

export function deleteSite(id) {
  return apiClient.delete(`/sites/${id}`);
}
